
import { PageRequest } from "@/store/shared/entity";
import {
  Component,
  Mixins,
  ActionButtonConfig,
  PageResultBaseMixins,
  PageResultModalMixins,
  appConst,
  PageResultListMixins,
} from "@/lib";
import EditInfoall from "./component/edit-infoall.vue";
import EditInfodownload from "./component/edit-infodownload.vue";
import BillOfLadingUploadModal from "./component/bill-of-lading-upload-modal.vue";
import BillOfLadingDownloadModal from "./component/bill-of-lading-download-modal.vue";
import ImportGoodsDetailModal from "./component/import-goods-detail-modal.vue";

class PageDeclareCustomsRequest extends PageRequest {
  ownerId:number;
  shippingNumber: string;
  businessGroup: string;
  customerName: string;
  receiver: string;
  payment: string;
  receiverAddress: string;
  shippingType: string;
  transaction: string;
  startPort: string;
  endtPort: string;
  countryOfArrival: string;
  tradingCountry: string;
  shippingMark: string;
  boxUnit: string;
  domesticSourceOfGood: string;
  packingType: string;
  remark: string;
  currency: string;
  status: string;
  document: string;
  colTitle:string;
  orderStyle:string;
  // 提单状态
  isUploadedBillOfLading:string;

  shipmentDate = [new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().slice(0,10),new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString().slice(0,10)];
}

@Component({
  name: "declarecustoms.list",
  components: { EditInfoall, EditInfodownload, BillOfLadingUploadModal, BillOfLadingDownloadModal, ImportGoodsDetailModal },
})
export default class DeclareCustomsView extends Mixins(
  PageResultBaseMixins,
  PageResultModalMixins,
  PageResultListMixins
) {
  sectionButtons = { ...this.addBtn() };

  data: any = {
    model: new PageDeclareCustomsRequest(),
    queryAction: "shipment/declarecustoms/getAll",
    isAutoQuery: true,
    cols: this.resultColumns,

  };
    async created() {
    // 不是业务组负责人，则默认查询单证为当前人
 if(this.currentUser.id==10){
      this.data.model.ownerId = this.currentUser.id;
 }
   
  }
  async activated() {
    await this.$store.dispatch("system/customer/getCustomerList");
      await this.$store.dispatch({
                 type:'system/userassignment/getUser'
             })
  }
 get currentUser() {
    return this.$store.state.currentUser.session.user;
  }
  reset() {
    this.data.model = new PageDeclareCustomsRequest();
    if(this.currentUser.id==10){
        this.data.model.ownerId = this.currentUser.id;
    }
  }
   get userList() {
         return this.$store.state.system.userassignment.userList;
        }   
  get resultColumns() {
    return [
      {
        title: this.L("app.DeclareCustoms.ShippingNumber"),
        key: "shippingNumber",
           minWidth: 150,
           sortable:'custom',
        render: (h: any, params: any) => {
          if (!!params.row.isUploadedBillOfLading) {
            return h("div", {}, [
              h("span", {}, params.row.shippingNumber),
              h("Icon", {
                props: {
                  type: "md-document",
                  size: 18
                },
                style: {
                  marginLeft: "8px"
                }
              }, ""),
            ])
          }
          return h("span", {}, params.row.shippingNumber);
        }
       
      },
      {
        title: this.L("app.DeclareCustoms.CustomerName"),
        key: "customerName",
        minWidth: 300,
      },

      this.$util.render.dateColumn(
        "app.DeclareCustoms.ShipmentDate",
        "shipmentDate",

        { width: 120 }
      ),

      {
        title: this.L("app.DeclareCustoms.ReceiverAmount"),
        key: "receiverAmount",
        minWidth: 200,
        render: (h: any, params: any) => {
          return [
            h("span", this.$util.format.amount(params.row.receiverAmount)),
          ];
        },
      },

      {
        title: this.L("app.DeclareCustoms.CustomsDeclarationAmount"),
        key: "customsDeclarationAmount",
         minWidth: 200,
        render: (h: any, params: any) => {
          return [
            h(
              "span",
              this.$util.format.amount(params.row.customsDeclarationAmount)
            ),
          ];
        },
      },
      this.$util.render.codeColumn(
        "app.DeclareCustoms.Status",
        "status",
        () =>
          this.getCodeListByCategory(
            appConst.codeCategory.declareCustomsStatus
          ),
        { width: 100,  sortable:'custom', key: "status",}
      ),

      // {
      //   title: this.L("app.DeclareCustoms.CreateType"),
      //   key: "createType",
      //   width: 120,
      //   render: (h: any, params: any) => {
      //     const map: Record<number, string> = { 1: "新增", 2: "复制", 3: "导入" };
      //     return h("span", map[params.row.createType] || "");
      //   }
      // },

      this.$util.render.datetimeColumn(
        "app.DeclareCustoms.CreationTime",
        "creationTime",
        { width: 200,  sortable:'custom', key: "creationTime"}
      ),
      this.$util.render.actions(this.colButtons, ()=>{return {fixed: "right"}})

    ];
  }

  get colButtons(): ActionButtonConfig[] {
    let buttons = [
      {
        label: "Action.Edit",
        permission: "RIMS.DeclareCustoms.Edit",
        check: (row) => {
          return (
            !this.setStatusCheck(row) && !this.setStatuscompletedCheck(row)&&row.isOwner
          );
        },
        callback: async (row: any) => {
          this.push("declarecustoms.edit", { id: row.id });
        },
      },
      {
        label: "Action.Detail",
        permission: "RIMS.DeclareCustoms",
        callback: async (row: any) => {
          this.push("declarecustoms.detail", { id: row.id });
        },
      },
      {
        label: "app.DeclareCustoms.Info",

        permission: "RIMS.DeclareCustoms.Edit",
        check: (row) => {
          return this.setStatusCheck(row)&&row.isOwner;
        },
        callback: async (row: any) => {
          this.push("declarecustoms.info", { id: row.id });
        },
      },

      {
        label: "app.DeclareCustoms.OtherInfo",

        permission: "RIMS.DeclareCustoms.Edit",
        check: (row) => {
          return this.setStatusCheck(row)&&row.isOwner;
        },
        callback: async (row: any) => {
          this.push("declarecustoms.otherinfo", { id: row.id });
        },
      },

      {
        label: "app.DeclareCustoms.Copy",
        permission: "RIMS.DeclareCustoms.Edit",
        check: (row) => {
          return !this.setStatusPendingCheck(row);
        },
        callback: async (row: any) => {
          this.push("declarecustoms.copy", { id: row.id });
        },
      },
      this.colDeleteBtn((row) => !this.setStatuscompletedCheck(row)&&row.isOwner),
      {
        label: "Action.Export",
        permission: this.$route.meta.access[0] + ".Export",
        callback: async (row) => {
          let response = await this.$store.dispatch({
            type: "shipment/declarecustoms/exportShipmentDetails",
            data: row,
          });
          this.$Message.success(this.L("Tip.ExportedSuccessfully"));
          let name = response.headers["content-disposition"].split("=")[1];
          this.$util.downloadFile(response.data, decodeURI(name));
        },
        check: (row) => {
          return this.setStatusDownload(row);
        },
      },
      {
        label: "app.DeclareCustoms.Information",

        permission: "RIMS.DeclareCustoms.Information",
        check: (row) => {
          return this.setStatusDownload(row);
        },
        callback: async (row: any) => {
          await this.$store.dispatch({
            type: "shipment/declarecustoms/get",
            id: row.id,
          });

          this.open("edit-infoall");
        },
      },
      {
        label: "app.DeclareCustoms.Download",

        permission: "RIMS.DeclareCustoms.Download",
        check: (row) => {
          return this.setStatusDownload(row);
        },
        callback: async (row: any) => {
          await this.$store.dispatch({
            type: "shipment/declarecustoms/get",
            id: row.id,
          });

          this.open("edit-infodownload");
        },
      },
      {
        label: "app.DeclareCustoms.BillOfLadingUpload",

        permission: "RIMS.DeclareCustoms.BillOfLadingUpload",
        check: (row) => {
          return (this.setStatusCheck(row) || this.setStatuscompletedCheck(row)) && row.chargeUserId == this.currentUser.id;
        },
        callback: async (row: any) => {
          this.$store.commit("shipment/declarecustoms/openBillOfLading", row.id);
          this.open("bill-of-lading-upload-modal");
        },
      },
      
    ];
    // 判断是否有
    let hasPermissionBillOfLadingDownload = this.hasPermission("RIMS.DeclareCustoms.BillOfLadingDownload") ? "RIMS.DeclareCustoms.BillOfLadingDownload" : (this.hasPermission("RIMS.DeclareCustoms.AllBillOfLadingDownload") ? "RIMS.DeclareCustoms.AllBillOfLadingDownload" : "");
    if (!!hasPermissionBillOfLadingDownload) {
      buttons.push({
        label: "app.DeclareCustoms.BillOfLadingDownload",

        permission: hasPermissionBillOfLadingDownload,
        check: (row) => {
          if (this.hasPermission("RIMS.DeclareCustoms.AllBillOfLadingDownload")) {
            return (this.setStatusCheck(row) || this.setStatuscompletedCheck(row)) && row.isUploadedBillOfLading;
          }
          return ((this.setStatusCheck(row) || this.setStatuscompletedCheck(row)) && row.isUploadedBillOfLading)
           && row.chargeUserId == this.currentUser.id;
        },
        callback: async (row: any) => {
          this.$store.commit("shipment/declarecustoms/openBillOfLading", row.id);
          this.open("bill-of-lading-download-modal");
        },
      })
    }
    return buttons;
  }
  createdeclarecustoms() {
    this.push("declarecustoms.add", {});
  }
  importGoodsDetail() {
    this.$store.commit("shipment/declarecustoms/openImportGoodsDetail");
    this.open("import-goods-detail-modal");
  }
  setStatusCheck = (row) => {
    return row.isProgress;
  };
  setStatusDownload = (row) => {
    return row.isProgress || row.status === appConst.declareCustomsStatus.completed;
  };
  setStatusPendingCheck = (row) => {
    return row.status === appConst.declareCustomsStatus.pending;
  };
  setStatuscompletedCheck = (row) => {
    return row.status === appConst.declareCustomsStatus.completed;
  };

  // sortChanged( {column, key, order} ) {
  //   debugger
  //   console.log(column);
  //    console.log(key);
  //     console.log(order);
  //     //order值可能为asc，desc，normal（不排序）
  //  this.data.model.colTitle=key;
  //   this.data.model.orderStyle=order;
  //   (this.$refs[this.$refsQueryBarName] as any).search();
  //     }

  //客户列表
  get customerList() {
    return this.$store.state.system.customer.customerList;
  }

  //状态
  get statusList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.declareCustomsStatus
    );
  }
  
  // 是否已上传提单
  get billOfLadingUploadStatusList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.billOfLadingUploadStatus
    );
  }
}
